// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2-c3T","header":"ClearentDisclaimer_header__CObXl","inner":"ClearentDisclaimer_inner__2EhV1"};